import { DataGridStateChange } from '@Reducers/util.reducer';
import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';

export const setDataGridState = createAction<DataGridStateChange>(
	addNamespace('util/dataGridState'),
);

export const setUniqueSelectedIds = createAction<string[]>(
	addNamespace('util/setUniqueSelectedIds'),
);

export const setUniqueSelectedStatus = createAction<string>(
	addNamespace('utils/setUniqueSelectedStatus'),
);
